import { getTiktokProxyImageSrc } from './tiktokProxy';
import useProxySrc from 'hooks/business/useProxySrc';
import { isString } from 'lodash-es';
import { useCallback } from 'react';

// 代理规则的实现集中在 lib/utils/tiktokProxy，这里保留原有导出以免调用方改动
export * from './tiktokProxy';

export const isBase64 = (src: string) => /^data:/.test(src);

export const isShopeePic = (src: string) => {
  return src ? !isBase64(src) && /^.+(\.shopee\.|\.img\.susercontent\.com).+/.test(src) : false;
};

export const isLazadaPic = (src: string) => {
  return src ? !isBase64(src) && /^.+\.slatic\.net\/.+/.test(src) : false;
};

export const lazadaPicCompress = (src: string, size?: number | `${number}x${number}`) => {
  if (!isLazadaPic(src)) {
    return src;
  }
  const url = new URL(src);
  if (size) {
    const targetSize = typeof size === 'string' ? size : `_${size}x${size}`;
    url.pathname = url.pathname.replace(/$/, targetSize);
  }
  url.pathname = url.pathname.replace(/$/, '.webp');
  url.host = 'img-ovs.alicdn.com';
  return url.href;
};

const http2https = (url?: string) => {
  if (url && isString(url) && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

export const getImageThumb = (url: string, platform?: General.CaselessPlatformTunnel) => {
  if (platform?.toUpperCase() === 'SHOPEE' && !url?.endsWith('_tn')) {
    const processedUrl = http2https(url);
    return `${processedUrl}_tn`;
  }

  if (platform?.toUpperCase() === 'LAZADA' && url) {
    return lazadaPicCompress(url, 128);
  }

  const transformedUrl = http2https(url);

  return transformedUrl || url;
};

export const useGetAvatarSrc = () => {
  const { getProxyEnable } = useProxySrc();

  return useCallback(
    (buyerAvatar: string, platform: General.PlatformUpperCaseTunnel) => {
      if (buyerAvatar.startsWith('https://graph.facebook.com')) {
        return '';
      }
      return getProxyEnable(buyerAvatar)
        ? getTiktokProxyImageSrc(buyerAvatar)
        : getImageThumb(buyerAvatar, platform);
    },
    [getProxyEnable],
  );
};
